<template>
  <div class="form-field form-field-text">
    <label :for="fieldRecap.name">{{ fieldRecap.label }}</label>
    <input
      :id="fieldRecap.name"
      :value="value"
      :name="fieldRecap.name"
      type="text"
      readonly
      @key.ENTER="handleClick"
      @click="handleClick"
    />
  </div>
</template>
<script setup lang="ts">
interface Props {
  fieldRecap: FieldRecap;
}

const props = defineProps({
  fieldRecap: null
});
const { gotoStep } = inject(INJECT_FORM_PAGE);

const route = useRoute();
const redirectPage = computed(() => {
  if (route.path.includes('/mon-compte')) {
    return `/mon-compte/modifier-mes-informations?continue=${route.path}`;
  } else {
    return `/profiling/informations?continue=${route.path}`;
  }
});

const handleClick = () => {
  if (props.fieldRecap.stepId) {
    gotoStep(props.fieldRecap.stepId);
  } else if (props.fieldRecap.isUserField) {
    navigateTo(redirectPage.value, { replace: true });
  }
};

const value = computed(() => {
  if (props.fieldRecap.name === 'birthdate') {
    return getFormatedBirthDate(props.fieldRecap.value);
  }
  return props.fieldRecap.value;
});
</script>
<style lang="scss" scoped>
input {
  cursor: pointer;

  &::selection {
    background: transparent;
  }
}
</style>
